import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { SignalRService } from '@services/SignalRService/SignalRService';
import { AppStateService } from './store/app-state.service';
import { MessengerService } from '@modules/messenger/messenger.service';
import { mergeMap, tap } from 'rxjs/operators';
import { HttpUserProfileService } from '@services/HttpServices/UserProfileHttpService/http-user-profile.service';
import { UsersCollectionService, UsersDataService } from './store/store-services';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { MobileDetectorService } from '@services/MobileDetectorService/mobile-detector.service';
import { PendoService } from './_services/pendo.service';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Platform } from '@ionic/angular';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription;

  constructor(
    private splashScreenService: SplashScreenService,
    private router: Router,
    private signalRService: SignalRService,
    public appStateService: AppStateService,
    private messengerService: MessengerService,
    private httpUserProfileService: HttpUserProfileService,
    private usersDataService: UsersDataService,
    private usersCollectionService: UsersCollectionService,
    private gtmService: GoogleTagManagerService,
    private mobileDetector: MobileDetectorService,
    private pendoService: PendoService,
    private platform: Platform
  ) {
    try {
      // Only lock orientation on native platforms
      if (this.platform.is('ios') || this.platform.is('android')) {
        ScreenOrientation.lock({ orientation: 'portrait' });
      }
    } catch (error) {
      console.log('ScreenOrientation API not available in this environment');
    }
  }

  ngOnInit() {
    this.mobileDetector.init();
    this.signalRService.ensureInitialized();
    
    // Initialize Pendo for anonymous users (will be updated on login)
    setTimeout(() => this.pendoService.initialize(), 1000);
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: event.url
        };
        this.gtmService.pushTag(gtmTag);
        // this.tableService.setDefaults();
        this.splashScreenService.hide();
        window.scrollTo(0, 0);
        // to display back the body content
        setTimeout(() => document.body.classList.add('page-loaded'), 500);
      }
    });

    this.appStateService.twilioToken$.pipe(
      tap((twilioToken) => this.messengerService.init(twilioToken)),
    ).subscribe();

    this.appStateService.authToken$.pipe(
      mergeMap((token) => !token ? [] : this.usersCollectionService.getWithQuery({
          PageNumber: '1',
          PageSize: '1000'
        }).pipe(tap(usersList => {
          (window as any).syncUsersWithTwilio = () => {
            for (const user of usersList) {
              this.messengerService.fetchTwilioToken(user.id).subscribe();
            }
          };
        }))
      ),
    ).subscribe(
      (token) => {
      },
      (error) => {
        console.warn('new auth token error', error);
      },
      () => {
      }
    );
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
    this.signalRService.stop();
  }
}
